import { ReactNode } from 'react';

type ButtonProps = {
  handleClickBtn?: () => void;
  variant:
    | 'outlined'
    | 'contained'
    | 'none'
    | 'outlined-danger'
    | 'outlined-black'
    | 'contained-color'
    | 'outlined-color';
  disabled?: boolean;
  label: string | ReactNode;
  classes?: string;
  children?: ReactNode;
  isLoading?: boolean;
  notificationCount?: number;
  variantColor?: string;
  iconPosition?: 'left' | 'right';
};

const Button = ({
  handleClickBtn,
  variant,
  disabled,
  label,
  classes,
  children,
  isLoading,
  notificationCount,
  variantColor,
  iconPosition = 'left'
}: ButtonProps) => {
  const applyClasses = () => {
    switch (variant) {
      case 'outlined':
        return 'border border-primary text-primary';
      case 'outlined-danger':
        return 'border border-[#D11C00] text-[#D11C00]';
      case 'outlined-black':
        return 'border border-black text-black bg-white';
      case 'contained':
        return 'border border-transparent bg-primary text-white';
      case 'contained-color':
        return `border border-transparent bg-[${variantColor ?? '#0C604A'}] text-white`;
      case 'outlined-color':
        return `border border-[${variantColor ?? '#0C604A'}] text-[${variantColor ?? '#0C604A'}]`;
      case 'none':
        return 'border border-primary text-alpha bg-primary';
      default:
        return 'border border-primary text-alpha bg-primary';
    }
  };

  return (
    <button
      className={`${applyClasses()} ${disabled ? 'disabled cursor-not-allowed opacity-50' : 'hover:cursor-pointer'} relative ml-2 inline-flex items-center justify-center gap-2 rounded-md px-6 py-3 text-base ${classes}`}
      onClick={handleClickBtn}
      disabled={disabled}
    >
      {iconPosition === 'left' && children}
      <span className='leading-none'>
        {label} {isLoading && <i className='fa fa-spinner fa-spin text-6' />}
      </span>
      {iconPosition === 'right' && children}
      {notificationCount !== undefined && notificationCount > 0 && (
        <span className='absolute right-0 top-0 flex h-5 w-5 -translate-y-1/2 translate-x-1/2 transform items-center justify-center rounded-full border border-red-600 bg-white text-xs text-red-600'>
          {notificationCount}
        </span>
      )}
    </button>
  );
};

export default Button;
